// extracted by mini-css-extract-plugin
export default {"container":"no-z","brandName":"oo-z","productName":"po-z","productNamePdpEnhancements":"qo-z","breakLongProductName":"ro-z"};